import { Component, Host, h, Prop } from '@stencil/core';
export class Dismiss {
  constructor() {
    /**
     * Sets dismiss button state to disabled.
     */
    this.disabled = false;
    /**
     * Sets dismiss size to large.
     */
    this.large = false;
  }
  render() {
    return (h(Host, null,
      h("sy-button", { class: "button-dismiss", content: "icon-only", icon: "close", disabled: this.disabled })));
  }
  static get is() { return "sy-dismiss"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "disabled": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets dismiss button state to disabled."
      },
      "attribute": "disabled",
      "reflect": true,
      "defaultValue": "false"
    },
    "large": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets dismiss size to large."
      },
      "attribute": "large",
      "reflect": true,
      "defaultValue": "false"
    }
  }; }
}
